<!-- eslint-disable vue/no-v-html -->
<template>
  <div>
    <PageHeading :default-heading="pageHeader" />
    <div class="pvd-container container-divider">
      <p>
        The customer is currently using this application or the primary trustee has signed off.
      </p>
    </div>
    <div
      class="pvd-container pvd-btn-row"
    >
      <div
        v-if="!isMaestro() && !isLiteView()"
        class="tertiary-link xsmall"
      >
        <a
          id="exit-overlay-modal-trigger"
          href="javascript:void(0)"
        >
          {{ modalExitVal }}
        </a>
      </div>
    </div>
    <ModalComponent
      :modal-header="modalHeader"
      :modal-body1="modalBody1"
      :modal-body2="modalBody2"
      :modal-footer="modalFooter"
      :modal-btn-url="modalUrl"
      :modal-btn-val="modalVal"
      id-val="exit-overlay-modal"
      @close-action="closeModal"
      @exitmodal-action="handleUrlClick"
    />
  </div>
</template>

<script>
import PageHeading from '../components/PageHeading.vue';
import dataHelper from '../mixins/dataHelper';
import measurement from '../mixins/measurement';
import utility from '../mixins/utility';
import constants from '../mixins/constants';
import ModalComponent from '../components/ModalComponent.vue';

export default {
  name: 'ApplicationUnavailable',
  components: {
    PageHeading,
    ModalComponent,
  },
  mixins: [dataHelper, measurement, utility],
  data() {
    return {
      backButtonAttempt: false,
      regType: '',
      pageHeader: 'Application Unavailable',
    };
  },
  computed: {
    // pageHeader() {
    //   return 'Application Unavailable';
    // },
    modalHeader() {
      return this.pd_content.exit_overlay_modal_header || constants.MODAL_HEADER;
    },
    modalBody1() {
      return this.pd_content.exit_overlay_modal_body1 || constants.MODAL_BODY1;
    },
    modalBody2() {
      return this.pd_content.exit_overlay_modal_body2 || constants.MODAL_BODY2;
    },
    modalFooter() {
      return this.pd_content.exit_overlay_modal_footer || constants.MODAL_FOOTER;
    },
    modalUrl() {
      let returnVal;
      if (this.$globalData.tStoreResponse && this.$globalData.tStoreResponse.exitURL) {
        if (this.$globalData.tStoreResponse.exitURL.method === 'POST') {
          returnVal = { url: this.$globalData.tStoreResponse.exitURL.url, method: 'POST' };
        } else {
          returnVal = this.$globalData.tStoreResponse.exitURL.url;
        }
      } else {
        returnVal = this.pd_content.overlay_exit_link ? this.pd_content.overlay_exit_link.all_accounts_url
          : constants.OVERLAY_EXIT_URL_LINK;
      }
      return returnVal;
    },
    modalVal() {
      return this.pd_content.overlay_exit_link ? this.pd_content.overlay_exit_link.value
        : constants.OVERLAY_EXIT_LINK_VAL;
    },
    modalExitVal() {
      return this.pd_content.exit_link ? this.pd_content.exit_link.value : constants.EXIT;
    },
    startApplication() {
      return this.pd_content.start_application_text || constants.START_NEW_APPLICATION;
    },
  },
  mounted() {
    this.configureBackButtonFunctionality(() => this.showBackWarning(
      this.backButtonWarning(document.location.pathname),
    ));
    this.track('trust-not-editable-error', 'pageview');
    document.title = this.setTitle(this.pageHeader);
    this.resetFormData();
    this.regType = this.getRegType(document.location.pathname);
  },
  methods: {
    backButtonWarning(url) {
      const reg = this.getRegType(url);
      if (constants.ROLLOVERIRA_REGTYPE === reg) {
        return this.pd_content.back_button_disabled_warning || constants.BACK_BUTTON_WARNING;
      }
      return this.pd_content.back_button_disabled_warning;
    },
    openChatWindow() {
      this.track('rep-chat-link', 'interaction');
      const url = this.pd_content.system_error_link ? this.pd_content.system_error_link.url
        : constants.CHAT_URL;
      document
        .querySelector('#question-overlay-modal')
        .setAttribute('active', 'false');
      this.openWindow(url, 'documentwindow', '650', '650');
    },
    closeModal() {
      document
        .querySelector('#exit-overlay-modal')
        .setAttribute('active', 'false');
    },
    handleUrlClick(url) {
      this.track('overlay_exit_link', 'interaction');
      if (typeof url === 'object') {
        this.submitForm(
          this.createForm(url.url, (
            this.$globalData.tStoreResponse && this.$globalData.tStoreResponse.params) ? this.$globalData.tStoreResponse.params : ''),
        );
      } else {
        window.location.assign(url);
      }
    },
  },
};
</script>

<style scoped>
    body {
        padding: 0 !important;
    }
</style>
